import React, { useEffect, useRef } from 'react';
import { useHasScrolled } from '@atlassiansox/bxp-content-framework';
import { getHeaderTheme } from './themes';
import { Header } from './UiHeader.styles';
import { HeaderLogo, HeaderNav, HeaderProgressBar } from './components';
import { useHeaderFooterContext, useIsLoggedIn } from '../../components';
export default function UiHeader({ model: { content: { appearance, addProgressBar, goToBoardsText, logInText, signUpText }, id } }) {
    const { backgroundColor, backgroundColorFixed, linkColor, linkColorHover } = getHeaderTheme(appearance);
    const hasScrolled = useHasScrolled(72);
    addProgressBar = addProgressBar === undefined ? false : addProgressBar;
    const { setHeaderHeight } = useHeaderFooterContext();
    const headerRef = useRef(null);
    const isLoggedIn = useIsLoggedIn();
    useEffect(() => {
        function handleResize() {
            if (headerRef.current) {
                const height = headerRef.current.offsetHeight;
                setHeaderHeight(height);
            }
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [headerRef, isLoggedIn, setHeaderHeight]);
    return (React.createElement(Header, { addProgressBar: addProgressBar, backgroundColor: backgroundColor, backgroundColorFixed: backgroundColorFixed, "data-scrolled": hasScrolled, linkColor: linkColor, linkColorHover: linkColorHover, ref: headerRef },
        React.createElement(HeaderLogo, { appearance: appearance, uuid: id }),
        React.createElement(HeaderNav, { appearance: appearance, goToBoardsText: goToBoardsText, logInText: logInText, isLoggedIn: isLoggedIn, signUpText: signUpText, uuid: id }),
        addProgressBar && React.createElement(HeaderProgressBar, null)));
}
//# sourceMappingURL=UiHeader.js.map